(() => {
  const selector = '.pills-variant-labels-text, .select-labels, .select-label, .canvas-cart-page__variant, .product-option dd, #cb-room-dialog option[value]';
  const pattern = /\b(\d+(?:[.,]\d+)?(?:\s*[x×]\s*\d+(?:[.,]\d+)?){1,2})\s*cm\b/gi;
  const format = value => value.replace(pattern, (_, dimensions) => dimensions.replace(/\s*[x×]\s*/gi, ' × ') + ' cm');
  const update = element => {
    if (element.closest('[contenteditable="true"]')) return;
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    let node;
    let changed = false;
    while ((node = walker.nextNode())) {
      const next = format(node.nodeValue);
      if (next !== node.nodeValue) {
        node.nodeValue = next;
        changed = true;
      }
    }
    if (changed || /\d\s×\s\d/.test(element.textContent)) element.classList.add('cb-size-display');
  };
  const scan = root => {
    if (root.nodeType !== Node.ELEMENT_NODE) return;
    if (root.matches(selector)) update(root);
    root.querySelectorAll(selector).forEach(update);
  };
  const pending = new Set();
  let scheduled = false;
  const enqueue = root => {
    if (!root) return;
    pending.add(root);
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      const roots = [...pending];
      pending.clear();
      roots.filter(root => root.isConnected).forEach(scan);
    });
  };
  scan(document.body);
  new MutationObserver(records => {
    for (const record of records) {
      const parent = record.target.nodeType === Node.TEXT_NODE ? record.target.parentElement : record.target;
      enqueue(parent?.closest(selector));
      record.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) enqueue(node);
      });
    }
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
